export const options = [
  { presentation: 'Overview', path: '/isometry'       },
  { presentation: 'North'   , path: '/isometry/north' },
  { presentation: 'South'   , path: '/isometry/south' }
]